export var StatesButtonStates;
(function (StatesButtonStates) {
    StatesButtonStates["IDLE"] = "IDLE";
    StatesButtonStates["IN_PROGRESS"] = "IN_PROGRESS";
    StatesButtonStates["SUCCESS"] = "SUCCESS";
    StatesButtonStates["FAILURE"] = "FAILURE";
})(StatesButtonStates || (StatesButtonStates = {}));
//# sourceMappingURL=types.js.map